export default "__VITE_ASSET__CsGJXILk__"